import React from 'react';

import { Link } from 'react-router-dom';


const Logo = ({limage, dimage, simage}) => {
    
    return (
        <Link to={process.env.PUBLIC_URL + "/"}>
            <img className="logo light-version-logo" src={window["logo_white"]} alt="logo" />
            <img className="logo dark-version-logo" src={window["logo_black"]} alt="logo" />
            <img className="logo sticky-logo" src={window["logo_white"]} alt="logo" />
        </Link>
    )
}


export default Logo;